import WebLayout from "../../../layout/WebLayout";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { useState } from "react";
import RegistrationAction from "../../../stores/actions/registrationAction";
type FormData = {
  name_of_entity: string;
  mobile: number;
  email: string;
  password: string;
};
function CreateBuyer() {
  const dispatch = useDispatch<any>();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<FormData>();

  const formHandleSubmit = async (data: any) => {
    setLoading(true);
    try {
      const result = await dispatch(
        RegistrationAction.createBuyer({
          name_of_entity: data.name_of_entity,
          mobile: data.mobile,
          email: data.email,
          password: data.password,
        })
      );
      if (result.status === false) {
        toast.error(result.msg);
        setLoading(false);
      } else {
        reset();
        navigate("/my-buyer-list");
        toast.success(result.msg);
      }
    } catch (error) {
      setLoading(false);
    }
  };
  return (
    <WebLayout pageName={"CreateBuyer"}>
      <div className="content-wrapper">
        <div className="container-fluid flex-grow-1 container-p-y">
          <div className="app-ecommerce">
            <form onSubmit={handleSubmit(formHandleSubmit)}>
              <div className="row">
                <div className="col-12 col-lg-8 offset-md-2">
                  <div className="card mb-4">
                    <div className="card-header">
                      <h4 className="mb-0">Registration Form – Buyer</h4>
                    </div>
                    <div className="card-body">
                      <div className="row mb-3">
                        <div className="col-lg-6">
                          <label className="form-label">
                            Name of Entity / Company{" "}
                            <small className={"text-danger"}>*</small>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Name of Entity / Company"
                            required={true}
                            {...register("name_of_entity")}
                          />
                        </div>
                        <div className="col-lg-6">
                          <label className="form-label">
                            Mobile No.{" "}
                            <small className={"text-danger"}>*</small>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Mobile No."
                            required={true}
                            {...register("mobile")}
                          />
                        </div>
                        <div className="col-lg-6">
                          <label className="form-label">
                            Email Id <small className={"text-danger"}>*</small>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Email Id"
                            required={true}
                            {...register("email")}
                          />
                        </div>
                        <div className="col-lg-6">
                          <label className="form-label">
                            Password <small className={"text-danger"}>*</small>
                          </label>
                          <input
                            type="password"
                            className="form-control"
                            placeholder="Password"
                            required={true}
                            {...register("password")}
                          />
                        </div>
                      </div>
                      <div className="col-md-2 ">
                        <button
                          type="submit"
                          disabled={loading}
                          className="btn btn-primary px-4">
                          {loading ? (
                            <i className={"fa fa-spinner fa-spin"}></i>
                          ) : null}
                          Submit
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </WebLayout>
  );
}

export default CreateBuyer;
